<template>
  <div class="card mb-2">
    <div class="card-header bg-primary text-white d-flex">
      <a v-b-toggle="`collapse-${title}-card`" class="collapse-icon c-pointer">
        <font-awesome-icon class="when-opened" icon='caret-down' size="lg" />
        <font-awesome-icon class="when-closed fa-w-10" icon='caret-right' size="lg" />
      </a>
      <span class="font-weight-bold">Documents</span>
    </div>
    <b-collapse
      v-model="showCollapse"
      :id="`collapse-${title}-card`"
      >
      <div class="card-body">
        <template>
          <h5 v-if="!folderId">
            No document folder found. Use the form below to add a document folder.
          </h5>
          <div v-if="folderId && showCollapse">
          <iframe
            :src="getBoxEmbedUrl()"
            width="100%"
            height="500"
            frameborder="0"
            allow="local-network-access *; clipboard-read *; clipboard-write *"
            allowfullscreen
            webkitallowfullscreen
            msallowfullscreen>
          </iframe>
          </div>
          <span>
            Don't see the folder you expect? Click
            <a class="text-secondary hyperlink" v-b-modal="'updateBoxFolder'"><u>here</u></a>
            to update the Box folder.
          </span>
          <b-button v-if="folderId && showCollapse"
            :href="getBoxUrl()"
            class="button-row-spacing float-right"
            target="_blank"
            rel="noopener noreferrer"
          >
            Open Box
          </b-button>
          <b-modal ref="updateBoxFolder"
            id="updateBoxFolder"
            title="Update Box Folder"
            centered
            size="lg"
            no-close-on-backdrop
          >
            <form @submit.prevent
              class="needs-validation"
              autocomplete="off"
              novalidate
            >
              <div v-if="serverError" class="alert alert-danger">{{serverError.folderId[0]}}</div>
              <LoadingSpinner v-if="submitting"
                :message="`Updating ${storeNamespace} Document Folder`"  size = '1x'>
              </LoadingSpinner>
              <div v-else class="row">
                <div class="col-lg-3 col-form-label label-text">
                  <span class="text-danger">*</span>Box Folder ID
                </div>
                <div class="col-lg-9">
                  <div class="input-group mb-2">
                    <div class="input-group-prepend">
                      <div class="input-group-text">https://app.box.com/folder/</div>
                    </div>
                    <input class="form-control"
                      name="newFolderId"
                      data-vv-as="Box Folder ID"
                      placeholder="Enter Box Folder ID"
                      v-model="newFolderId"
                      v-validate="'required|numeric'"
                    >
                  </div>
                  <small class="form-text text-muted">
                    Copy and paste the Folder ID from the Box URL to use for this {{storeNamespace}} (e.g., if the URL is https://app.box.com/folder/1234567890, copy and paste 1234567890 into the field).
                  </small>
                  <div v-if="errors.first('newFolderId')" class="invalid-feedback d-block">
                    {{ errors.first('newFolderId') }}
                  </div>
                </div>
              </div>
            </form>
            <div slot="modal-footer" class="d-flex justify-content-center w-100">
              <b-button variant="danger" class="button-row-spacing" @click="hideModal">
                Cancel
              </b-button>
              <b-button class="button-row-spacing"
                @click="updateBoxFolder(newFolderId)"
              >
                Update
              </b-button>
            </div>
          </b-modal>
        </template>
      </div>
    </b-collapse>
  </div>
</template>

<script>

import CollapseControl from '@/mixins/CollapseControl';
import LoadingSpinner from '../LoadingSpinner.vue';

export default {
  name: 'BoxCard',
  components: {
    LoadingSpinner,
  },
  mixins: [CollapseControl],
  data() {
    return {
      title: 'Documents',
      newFolderId: '',
      showCollapse: false,
    };
  },
  props: {
    folderId: String,
    storeNamespace: String,
    parentId: Number,
  },
  computed: {
    submitting() {
      return this.$store.state[this.storeNamespace].submitting;
    },
    serverError() {
      return this.$store.state[this.storeNamespace].serverError;
    },
  },
  methods: {
    getBoxEmbedUrl() {
      return `https://vof.box.com/embed/folder/${this.folderId}?sortColumn=date&view=list&partner_id=447`;
    },
    getBoxUrl() {
      return `https://app.box.com/folder/${this.folderId}?sortColumn=date&view=list&partner_id=447`;
    },
    updateBoxFolder(folderId) {
      this.$validator.validate()
        .then((result) => {
          if (result) {
            this.$store.dispatch(`${this.storeNamespace}/updateDocumentFolder`, { id: this.parentId, folderId })
              .then(() => {
                if (!this.serverError) this.updated();
              });
          }
        });
    },
    hideModal() {
      this.$refs.updateBoxFolder.hide();
    },
    updated() {
      this.hideModal();
      this.newFolderId = '';
    },
  },
};
</script>
